import { memo } from 'react';
import { IntervalRenderer, TimelineHeaderHourIndicatorsStatic } from '@modules/timetable';
import dynamic from 'next/dynamic';

const DateHeader = dynamic(() => import('react-calendar-timeline').then((module) => module.DateHeader), {
  ssr: false,
});

export const TimelineDateHeader = memo(() => {
  return (
    <DateHeader
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      intervalRenderer={({ getIntervalProps, intervalContext }: IntervalRenderer) => {
        return (
          <>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <div {...getIntervalProps()}>
              <div className="timeline-header-title">{intervalContext.intervalText}</div>
              {TimelineHeaderHourIndicatorsStatic}
            </div>
          </>
        );
      }}
      unit="day"
      height={50}
      labelFormat="dddd Do "
    />
  );
});
